import styled from '@emotion/styled';

export const RangeFilterItem = styled.div`
  width: 50%;
  & + & {
    margin-left: 11px;
  }
`;
